import { motion } from 'framer-motion';
import PROJECTS from '../data/projects';

const Projects = () => {
  return (
    <section id="work" className="section projects">
      <div className="section__inner">
        <motion.p
          className="section__eyebrow"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Selected work
        </motion.p>
        <motion.h2
          className="section__title"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.08 }}
        >
          Projects that define the craft
        </motion.h2>

        <div className="projects__grid">
          {PROJECTS.map((project, index) => (
            <motion.article
              key={project.id}
              className={`project${project.featured ? ' project--featured' : ''}`}
              initial={{ opacity: 0, y: 48 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{
                duration: 0.75,
                delay: (index % 3) * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -6 }}
            >
              <div
                className="project__media"
                style={{ '--accent': project.accent }}
              >
                {project.cover ? (
                  <img
                    src={`${process.env.PUBLIC_URL}/${project.cover}`}
                    alt={`${project.title} preview`}
                    loading="lazy"
                  />
                ) : (
                  <div className="project__fallback" aria-hidden="true">
                    <span>{project.title.slice(0, 2).toUpperCase()}</span>
                  </div>
                )}
                <div className="project__shine" />
              </div>

              <div className="project__body">
                <h3>{project.title}</h3>
                <p>{project.desc}</p>
                <ul className="project__tags">
                  {project.tags.map((tag) => (
                    <li key={tag}>{tag}</li>
                  ))}
                </ul>
                <div className="project__actions">
                  {project.liveUrl && (
                    <a
                      className="btn btn--fill btn--sm"
                      href={project.liveUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Live
                    </a>
                  )}
                  {project.codeUrl && (
                    <a
                      className="btn btn--ghost btn--sm"
                      href={project.codeUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Code
                    </a>
                  )}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
